import { defineComponent as _defineComponent } from 'vue'
import DialogDetalhesDoServico from '@/components/servico/DialogDetalhesDoServico.vue'
import { Servico } from 'common/types/Servico'


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemServico',
  props: {
    item: null
  },
  setup(__props: any) {



return { __sfc: true,DialogDetalhesDoServico }
}

})